<template>
  <div class="diaglog-wrapper">
    <transition name="fade-in">
      <div class="dialog-mask"></div>
    </transition>
    <transition name="scale-in" @after-leave="closePopup">
      <article v-if="showContent" class="dialog-container tips-dialog">
        <div class="tips-dialog-wrapper">
          <h1 class="dialog-title">
            {{ languages.quickcard_info_title }}
          </h1>
          <div class="tips-content">
            <p class="left-text">{{ languages.quickcard_info_tip_one }}</p>
            <p class="left-text">{{ languages.quickcard_info_tip_two }}</p>
          </div>
        </div>
        <button class="sure-btn" @click="hideContent">
          {{ languages.confirm }}
        </button>
        <button class="close-btn" @click="hideContent"></button>
      </article>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'quickPayCardPopup',
  props: {
    languages: {
      require: true
    }
  },
  data() {
    return {
      showContent: false
    }
  },
  mounted() {
    this.showContent = true
  },
  beforeDestroy() {
    this.showContent = false
  },
  methods: {
    closePopup() {
      this.$emit('close')
    },
    hideContent() {
      this.showContent = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.dialog-mask {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
}
.dialog-container.tips-dialog {
  overflow: -moz-scrollbars-none;
  overflow-y: auto;
  position: relative;
  padding: 0;
  height: auto;
  background-size: 100% 100%;
  text-align: center;

  -ms-overflow-style: none;
  scrollbar-width: none;
  @psetbg ('common-popup.png', true,false);
  &::-webkit-scrollbar {
    display: none;
    width: 0 !important;
  }
}
.tips-content {
  padding: 0 60px;
  line-height: 35px;
  text-align: left;
  font-size: 28px;
}
.close-btn {
  position: absolute;
  right: 46px;
  top: 36px;
  z-index: 10;
  background-size: 100% 100%;
}
.sure-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 80px auto 54px;
  background-size: cover;
  font-size: 36px;
  color: #fff;
  @psetbg ('confirm.png');
}
.tips-dialog-wrapper {
  height: auto;
  min-height: unset;
}
@media screen and (orientation: landscape) {
  .dialog-container.tips-dialog {
    // 这里
    text-align: center;
    @psetbg ('common-popup-hen.png', true,false);
  }
  .close-btn {
    position: absolute;
    right: 31px;
    top: 23px;
    z-index: 10;
    cursor: pointer;
  }
  .sure-btn {
    margin-top: 13px;
    line-height: 53px;
    font-size: 24px;
    @psetbg ('confirm-hen.png');
  }
  .tips-content {
    padding: 0 42px;
    line-height: 30px;
    font-size: 18px;
  }
}

</style>
